import MSCartesian from '@fusioncharts/charts/src/chart/_internal/mscartesian';
import LineDataset from '@fusioncharts/charts/src/dataset/line';
import { _setDefaultConfig } from '@fusioncharts/charts/src/chart/_internal/areabase';
let LINE = 'line';
class InverseMSLine extends MSCartesian {
  /**
   * Provides the name of the chart extension
   *
   * @static
   * @return {string} The name of the chart extension
   */
  static getName () {
    return 'InverseMSLine';
  }

  constructor () {
    super();
    this.defaultPlotShadow = 1;
  }
  /**
   * Sets the name of the component
   * @return {string} name
   */
  getName () {
    return 'InverseMSLine';
  }
  /**
   * parse defualt configuration of the chart
   */
  __setDefaultConfig () {
    super.__setDefaultConfig();
    let config = this.config;

    config.defaultDatasetType = LINE;
    config.isInverse = true;
    config.zeroplanethickness = 1;
    config.zeroplanealpha = 4;
    config.showzeroplaneontop = 0;
    config.enablemousetracking = true;
    config.defaultcrosslinethickness = 1;
    _setDefaultConfig.call(this);
  }
  getDSdef () {
    return LineDataset;
  }
  getDSGroupdef () {
    // this fn overrides
  }
}
export default InverseMSLine;
